import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';

function ContentCustomer({ customerText, image, nameCustomer, functie })
{
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
      <div>
        <p>{customerText}</p>
      </div>
      <div>
        <GatsbyImage image={getImage(image)} alt={nameCustomer} className="rounded-full w-52 h-52" imgClassName="rounded-full" />
        <h4 className="font-semibold">{nameCustomer}</h4>
        <p>{functie}</p>
      </div>
    </div>
  );
}


export default ContentCustomer;